/**
 * Stops browser-owned media streams that can outlive a React/Jitsi cleanup path.
 */
export function releaseBrowserMediaDevices() {
    document.querySelectorAll('video, audio').forEach(element => {
        const mediaElement = element;
        const stream = mediaElement.srcObject;
        if (stream instanceof MediaStream) {
            stream.getTracks().forEach(track => {
                track.stop();
                track.enabled = false;
            });
        }
        mediaElement.srcObject = null;
    });
}
